import InfoIcon from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';

import { getMessage } from '@shared/utils';
import './EmptyMessage.scss';

const EmptyMessage = ({ message = getMessage('noData') }) => {
  return (
    <Box className="empty-message">
      <InfoIcon />
      <p className="text">{message}</p>
    </Box>
  );
};

EmptyMessage.propTypes = {
  message: PropTypes.string,
};

export default EmptyMessage;
